import { Button, Tooltip } from '@mui/material';
import { LoadingButton } from '@mui/lab';

type FormActionsProps = {
    isUpdate: boolean;
    disabled?: boolean;
    loading?: boolean;
    onSave: () => void;
    onCancel: () => void;
    tooltip?: string;
};

export const FormActions = ({
    tooltip = '',
    isUpdate,
    disabled = false,
    loading = false,
    onSave,
    onCancel,
}: FormActionsProps) => {
    return (
        <>
            <Tooltip title={tooltip} open={Boolean(tooltip)} placement='top' arrow>
                <span>
                    <LoadingButton
                        type='submit'
                        loading={loading}
                        disabled={disabled}
                        size={'large'}
                        variant={'contained'}
                        color={'orange'}
                        onClick={onSave}>
                        {!isUpdate ? 'Create' : 'Update'}
                    </LoadingButton>
                </span>
            </Tooltip>

            <Button type='button' size={'large'} variant={'outlined'} color={'orange'} onClick={onCancel}>
                Cancel
            </Button>
        </>
    );
};
